import { Component, Input, Output, EventEmitter, HostListener, ElementRef, OnChanges, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.css'],
    standalone: false,
    host: { class: 'app-dialog--standard', '[class.app-dialog--sheet]': "presentation === 'sheet'" }
})
export class DialogComponent implements OnChanges, OnDestroy {
  private static nextId = 0;
  readonly titleId = `app-dialog-title-${++DialogComponent.nextId}`;
  @Input() presentation: 'dialog' | 'sheet' = 'dialog';
  private previousFocus: HTMLElement;
  private focusTimer: ReturnType<typeof setTimeout>;
  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(): void {
    clearTimeout(this.focusTimer);
    if (this.visible) {
      if (!this.previousFocus) this.previousFocus = document.activeElement as HTMLElement;
      this.focusTimer = setTimeout(() => {
        const title = this.element.nativeElement.querySelector<HTMLElement>('.modal-header h4, .modal-header h5');
        const dialog = this.element.nativeElement.querySelector<HTMLElement>('[role="dialog"]');
        if (title) { title.id = this.titleId; dialog?.setAttribute('aria-labelledby', this.titleId); }
        dialog?.focus();
      });
    } else this.restoreFocus();
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (!this.visible) return;
    if (event.key === 'Escape') {
      event.stopPropagation();
      this.close();
    }
    if (event.key !== 'Tab') return;
    const controls = Array.from(this.element.nativeElement.querySelectorAll<HTMLElement>(
      'button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]'
    )).filter(control => control.getClientRects().length > 0);
    const first = controls[0], last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || document.activeElement?.getAttribute('role') === 'dialog')) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  }

  private restoreFocus(): void {
    if (this.previousFocus?.isConnected) this.previousFocus.focus();
    this.previousFocus = null;
  }
  ngOnDestroy(): void { clearTimeout(this.focusTimer); this.restoreFocus(); }

  @Input() closable = true;
  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public close(): void {
    if (!this.closable) return;
    this.restoreFocus();
    let me = this;
    me.visible = false;
    me.visibleChange.emit(me.visible);
  }
}
